import React, { useEffect, useState, useCallback } from 'react';
import './DashboardEditarAnuncio.scss';
import { useAuth } from '../../../../context/AuthContext';
import api from '../../../../config/configApi';
// import * as Photos from '../../../../services/photos';
import { logError, logUsuarioForm } from '../../../../services/logService';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Alert, Box, Breadcrumbs, Button, Chip, CircularProgress, FormControl, FormHelperText, FormLabel, MenuItem, OutlinedInput, Select, TextField } from '@mui/material';
import { styled, emphasize } from '@mui/material/styles';
import { MdClear, MdHome, MdImage } from 'react-icons/md';
import { NumericFormat } from 'react-number-format';
import Resizer from 'react-image-file-resizer';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { isEmpty } from 'lodash';
import toast from 'react-hot-toast';

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
    return {
        backgroundColor: theme.palette.grey[100],
        height: theme.spacing(3),
        color: (theme.vars || theme).palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover, &:focus': {
            backgroundColor: emphasize(theme.palette.grey[100], 0.06),
            ...theme.applyStyles('dark', {
                backgroundColor: emphasize(theme.palette.grey[800], 0.06),
            }),
        },
        '&:active': {
            boxShadow: theme.shadows[1],
            backgroundColor: emphasize(theme.palette.grey[100], 0.12),
            ...theme.applyStyles('dark', {
                backgroundColor: emphasize(theme.palette.grey[800], 0.12),
            }),
        },
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    };
});

const CustomFormControl = styled(FormControl)(({ theme }) => ({
    '& .MuiOutlinedInput-root': {
        '&.Mui-focused fieldset': {
            borderColor: theme.palette.primary.main, // Cor da borda ao focar
        },
    },
    '& .MuiInputLabel-root': {
        color: theme.palette.text.secondary, // Cor do label padrão
        '&.Mui-focused': {
            color: theme.palette.primary.main, // Cor do label ao focar
        },
    },
}));

const StyledFormLabel = styled(FormLabel)(({ theme }) => ({
    fontSize: '12px',
    fontWeight: 500,
    marginBottom: '5px',
}));

function DashboardEditarAnuncio() {
    const { user } = useAuth();
    const { veiculoId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    // Estado de foco
    const [anoFabFocused, setAnoFabFocused] = useState(null);
    const [anoModeloFocused, setAnoModeloFocused] = useState(null);
    const [modeloFocused, setModeloFocused] = useState(null);
    const [kmFocused, setKmFocused] = useState(null);
    const [valorFocused, setValorFocused] = useState(null);
    const [observacaoFocused, setObservacaoFocused] = useState(null);

    // Estado para imagens
    const [existingImages, setExistingImages] = useState([]); // IMAGENS JÁ EXISTENTES (do backend)
    const [newlySelectedFiles, setNewlySelectedFiles] = useState([]); // NOVOS arquivos File que o usuário selecionou
    const [allPreviewURLs, setAllPreviewURLs] = useState([]); // TODAS as URLs para preview (existentes + novas)
    const [imagesToDeleteBackend, setImagesToDeleteBackend] = useState([]); // IDs ou paths de imagens EXISTENTES que foram removidas    
    const [uploadResult, setUploadResult] = useState(null);
    const [uploadError, setUploadError] = useState(null);
    const maxImagens = 15;

    // Estado para controle de disable botoes e inputs durante submit
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [disableDeleteImg, setDisableDeleteImg] = useState(false);

    const [firebaseDeleteError, setFirebaseDeleteError] = useState(false);
    const [firebaseUploadError, setFirebaseUploadError] = useState(false);

    const [editValues, setEditValues] = useState({});
    const [errorEditValues, setErrorEditValeus] = useState(null);
    const [error, setError] = useState({
        marca_id: null,
        ano_fabricacao: null,
        ano_modelo: null,
        tipo: null,
        modelo: null,
        direcao: null,
        cor: null,
        combustivel: null,
        cambio: null,
        tracao: null,
        carroceria: null,
        km: null,
        valor: null,
        observacao: null,
        imagem: null,
    });

    useEffect(() => {
        const fetchVehicleData = async () => {
            try {
                setLoading(true);
                const response = await api.get(`/api/anuncio/${veiculoId}`);
                const fetchedVehicle = response.data;
                setEditValues(fetchedVehicle);

                if (fetchedVehicle.imagens && fetchedVehicle.imagens.length > 0) {
                    setExistingImages(fetchedVehicle.imagens); // Popula imagens existentes                    

                    // Constrói as URLs de preview iniciais com as ftp_url das imagens existentes
                    const initialPreviewUrls = fetchedVehicle.imagens.map(img => img.ftp_url);
                    setAllPreviewURLs(initialPreviewUrls);
                    // O selectedFiles deve permanecer vazio aqui, pois são imagens já existentes.
                    // Elas não são "arquivos selecionados" para um novo upload.
                } else {
                    setExistingImages([]);
                    setAllPreviewURLs([]); // Se não houver imagens, o previewURLs fica vazio
                }
            } catch (err) {
                const errMessage = err.response?.data?.msg || err.message || 'Erro desconhecido ao carregar veículo.';
                setErrorEditValeus(errMessage);
            } finally {
                setLoading(false);
            }
        }

        fetchVehicleData();
    }, [veiculoId])

    // Funcoes de visibilidade dos campos
    let showFields;
    // CATEGORIA CARRETA
    let showDirecao;
    let showCombustivel;
    let showCambio;
    let showKm;
    // CATEGORIA CARRO E CARRETA
    let showTracao;
    let showCarroceria;
    // CATEGORIA CAMINHAO E CARRO
    let showTipo;
    let showModeloSelect;

    const handleChange = (e) => {
        setEditValues((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    }

    const handleKeyPress = (e) => {
        if (!/[0-9]/.test(e.key)) e.preventDefault()
    }

    const handleNumericInputChange = (values, name) => {
        setEditValues((prev) => ({
            ...prev,
            [name]: values.value ? parseFloat(values.value) : '', // Mantém como string para KM
        }));
    };

    const handleImageChange = async (event) => {
        const files = Array.from(event.target.files);

        if (files.length === 0) return

        let totalSelecionadas = existingImages.length + newlySelectedFiles.length + files.length;

        if (totalSelecionadas > maxImagens) {
            toast(`Selecione no máximo ${maxImagens} imagens!`, { icon: '⚠️' });
            setError(prev => ({ ...prev, imagem: `Você só pode selecionar no máximo ${maxImagens} imagens.` }));
            return;
        }
        setError(prev => ({ ...prev, imagem: null })); // Limpa erro de imagem se houver

        const resizedFilesPromises = files.map(file => {
            return new Promise((resolve, reject) => {
                Resizer.imageFileResizer(
                    file,
                    1920,
                    1440,
                    'JPEG',
                    90, // Qualidade ligeiramente reduzida para otimização
                    0,
                    (resizedFile) => {
                        resolve(resizedFile);
                    },
                    'blob'
                );
            });
        });

        try {
            const newResizedFiles = await Promise.all(resizedFilesPromises);
            const newPreviewURLsFromFiles = newResizedFiles.map(file => URL.createObjectURL(file));

            setNewlySelectedFiles((prev) => [...prev, ...newResizedFiles]); // Adiciona aos novos arquivos
            setAllPreviewURLs((prev) => [...prev, ...newPreviewURLsFromFiles]); // Adiciona às URLs de preview gerais
        } catch (err) {
            toast.error('Erro ao processar algumas imagens.');
        }
    };

    const handleDeleteImage = (urlToDelete) => {
        // 1. Remove a URL do array geral de previews
        setAllPreviewURLs(prevURLs => {
            // Revoga a URL do objeto se for uma (para liberar memória)
            if (urlToDelete.startsWith('blob:')) {
                URL.revokeObjectURL(urlToDelete);
            }
            return prevURLs.filter(url => url !== urlToDelete);
        });

        // 2. Tenta remover do array de NOVOS arquivos
        setNewlySelectedFiles(prevFiles => {
            // Encontra o arquivo correspondente à URL, se for um blob URL
            const fileToRemove = prevFiles.find(file => URL.createObjectURL(file) === urlToDelete);
            if (fileToRemove) {
                // Se encontrou, significa que era um arquivo novo, então remova-o
                return prevFiles.filter(file => file !== fileToRemove);
            }
            return prevFiles; // Não era um arquivo novo
        });

        // 3. Tenta remover do array de IMAGENS EXISTENTES e marca para deleção no backend
        setExistingImages(prevExistingImages => {
            const imageToDelete = prevExistingImages.find(img => img.ftp_url === urlToDelete);
            if (imageToDelete) {
                // Se encontrou, é uma imagem existente. Adiciona seu ID ou storage_path
                // à lista de imagens para deletar no backend.
                setImagesToDeleteBackend(prevToDelete => [...prevToDelete, { id: imageToDelete.id, veiculo_id: Number(veiculoId), nome: imageToDelete.nome, storage_path: imageToDelete.storage_path }]); // Ou imageToDelete.id
                return prevExistingImages.filter(img => img.ftp_url !== urlToDelete);
            }
            return prevExistingImages; // Não era uma imagem existente
        });

        // 4. Limpa erro de limite de imagens, se aplicável
        if (allPreviewURLs.length - 1 < maxImagens) { // Verifica o tamanho do array de previews após a remoção
            setError(prev => ({ ...prev, imagem: null }));
        }
    }

    // Função de validação centralizada
    const validateForm = useCallback(() => {
        let currentErrors = {};
        let formIsValid = true;

        // Validações comuns a todas as categorias
        if (editValues.marca_id === '') {
            currentErrors.marca_id = 'Selecione uma marca';
            formIsValid = false;
        }

        if (isEmpty(JSON.stringify(editValues.ano_fabricacao)) || JSON.stringify(editValues.ano_fabricacao).length < 4 || isNaN(Number(editValues.ano_fabricacao))) {
            currentErrors.ano_fabricacao = 'Informe o ano da fabricação (4 dígitos)';
            formIsValid = false;
        } else if (Number(editValues.ano_fabricacao) > new Date().getFullYear() + 1 || Number(editValues.ano_fabricacao) < 1900) {
            currentErrors.ano_fabricacao = 'Ano inválido';
            formIsValid = false;
        }
        if (isEmpty(JSON.stringify(editValues.ano_modelo)) || JSON.stringify(editValues.ano_modelo).length < 4 || isNaN(Number(editValues.ano_modelo))) {
            currentErrors.ano_modelo = 'Informe o ano modelo (4 dígitos)';
            formIsValid = false;
        } else if (Number(editValues.ano_modelo) < Number(editValues.ano_fabricacao) || Number(editValues.ano_modelo) > new Date().getFullYear() + 1) {
            currentErrors.ano_modelo = 'Ano modelo inválido';
            formIsValid = false;
        }
        if (isEmpty(editValues.modelo)) {
            currentErrors.modelo = 'Informe o modelo';
            formIsValid = false;
        }
        if (isEmpty(editValues.cor)) {
            currentErrors.cor = 'Informe a cor';
            formIsValid = false;
        }
        if (isEmpty(String(editValues.km)) || editValues.km < 0) { // KM pode ser 0
            currentErrors.km = 'Informe a km (deixe 0 para consulte)';
            formIsValid = false;
        }
        if (isEmpty(String(editValues.valor)) || editValues.valor < 0) { // Valor pode ser 0
            currentErrors.valor = 'Informe o valor (deixe 0 para consulte)';
            formIsValid = false;
        }
        if (isEmpty(editValues.observacao)) {
            currentErrors.observacao = 'Informe a observação';
            formIsValid = false;
        }

        const totalImages = existingImages.length + newlySelectedFiles.length;

        if (totalImages === 0) {
            currentErrors.imagem = 'Selecione as imagens do anúncio';
            formIsValid = false;
        } else if (totalImages > maxImagens) {
            currentErrors.imagem = `Você só pode ter no máximo ${maxImagens} imagens.`;
            formIsValid = false;
        } else {
            // Limpa o erro de imagem se o número de imagens for válido
            currentErrors.imagem = null;
        }

        // Validações específicas por categoria
        const categoriaId = Number(editValues.categoria_id);
        if (categoriaId === 1) { // Caminhão
            if (isEmpty(editValues.combustivel)) { currentErrors.combustivel = 'Informe o combustível'; formIsValid = false; }
            if (isEmpty(editValues.cambio)) { currentErrors.cambio = 'Informe o câmbio'; formIsValid = false; }
            if (isEmpty(editValues.direcao)) { currentErrors.direcao = 'Informe a direção'; formIsValid = false; }
            if (isEmpty(editValues.tracao)) { currentErrors.tracao = 'Informe a tração'; formIsValid = false; }
            if (isEmpty(editValues.carroceria)) { currentErrors.carroceria = 'Informe a carroceria'; formIsValid = false; }
        } else if (categoriaId === 2) { // Carreta
            // Campos não aplicáveis são removidos no updatededitValues, não validamos aqui
            if (isEmpty(editValues.tipo)) { currentErrors.tipo = 'Informe o tipo'; formIsValid = false; }
        } else if (categoriaId === 3) { // Carro
            // Campos não aplicáveis são removidos no updatededitValues, não validamos aqui
            if (isEmpty(editValues.combustivel)) { currentErrors.combustivel = 'Informe o combustível'; formIsValid = false; }
            if (isEmpty(editValues.cambio)) { currentErrors.cambio = 'Informe o câmbio'; formIsValid = false; }
            if (isEmpty(editValues.direcao)) { currentErrors.direcao = 'Informe a direção'; formIsValid = false; }
        }

        setError(currentErrors); // Atualiza todos os erros de uma vez
        return formIsValid;
    }, [editValues, existingImages, newlySelectedFiles, maxImagens]); // Depende do editValues e selectedFiles para reavaliar a validação

    const handleSubmit = async (e) => {
        e.preventDefault();

        setIsButtonDisabled(true);
        setDisableDeleteImg(true);

        let formDataToSubmit = { ...editValues };

        formDataToSubmit.categoria_id = editValues.categoria.id;

        if (!editValues.marca_id) {
            formDataToSubmit.marca_id = editValues.marca.id;
        }

        formDataToSubmit.modelo = editValues.modelo.toUpperCase();
        formDataToSubmit.ano_fabricacao = parseInt(editValues.ano_fabricacao);
        formDataToSubmit.ano_modelo = parseInt(editValues.ano_modelo);

        delete formDataToSubmit.categoria;
        delete formDataToSubmit.marca;
        delete formDataToSubmit.imagens;
        delete formDataToSubmit.created_at;
        delete formDataToSubmit.updated_at;
        delete formDataToSubmit.visualizacoes;
        // Remove campos baseados na categoria antes da validação final para o backend
        const categoriaId = Number(formDataToSubmit.categoria_id);
        if (categoriaId === 1) { // Caminhao
            delete formDataToSubmit.tipo;
        }
        if (categoriaId === 2) { // Carreta
            delete formDataToSubmit.direcao;
            delete formDataToSubmit.combustivel;
            delete formDataToSubmit.cambio;
            delete formDataToSubmit.km;
            delete formDataToSubmit.tracao;
            delete formDataToSubmit.carroceria;
        } else if (categoriaId === 3) { // Carro
            delete formDataToSubmit.tipo;
            delete formDataToSubmit.tracao;
            delete formDataToSubmit.carroceria;
        }

        // Valida o formulário
        const formIsValid = validateForm();
        if (!formIsValid) {
            toast.error('Por favor, corrija os erros no formulário.');
            setIsButtonDisabled(false); // Reabilita o botão
            setDisableDeleteImg(false);
            return;
        }

        // Garante que o usuario_id esteja setado. Caso não esteja, é um erro crítico.
        if (formDataToSubmit.usuario_id === null) {
            toast.error('Erro: ID do usuário não disponível. Tente novamente.');
            await logError({
                email: user?.email || 'N/A',
                log_erro: 'Usuario_id nulo no momento do submit do formulário de anúncio.',
                formulario: location.pathname,
            });
            setIsButtonDisabled(false);
            setDisableDeleteImg(false);
            return;
        }

        let hasCriticalError = false;
        let uploadedImageDetails = [];

        const toastId = toast.loading('Iniciando atualização do veículo...');

        // 1. DELETAR IMAGENS MARCADAS PARA EXCLUSAO SE HOUVER
        if (imagesToDeleteBackend.length > 0) {
            // Deleta no firebase storage
            // try {
            //     toast.loading('Excluindo imagens na nuvem...', { id: toastId });
            //     const results = await Promise.allSettled(imagesToDeleteBackend.map(async (image) => {
            //         await Photos.deleteImage(image.storage_path, image.nome);
            //     }));

            //     const failedDeletions = results.filter(r => r.status === 'rejected');
            //     if (failedDeletions.length > 0) {
            //         const errorMessage = `Erro ao deletar ${failedDeletions.length} imagens na nuvem.`;
            //         toast.error(errorMessage, { id: toastId });
            //         await logError({
            //             email: user?.email || 'N/A',
            //             log_erro: `Falha ao deletar imagens no Firebase do Veículo ${editValues?.id}: ${JSON.stringify(failedDeletions)}`,
            //             formulario: location.pathname,
            //         });
            //         hasCriticalError = true;
            //     } else {
            //         toast.success('Imagens deletadas na nuvem com sucesso!', { id: toastId });
            //     }
            // } catch (errorDeleteFirebaseImg) {
            //     // Este catch pegará erros que podem ter escapado de Promise.allSettled
            //     const errorMessage = errorDeleteFirebaseImg.message || 'Erro crítico ao deletar imagens na nuvem.';
            //     toast.error(errorMessage, { id: toastId });
            //     await logError({
            //         email: user?.email || 'N/A',
            //         log_erro: `Erro crítico inesperado ao deletar imagens do Veículo ${editValues?.id}: ${errorMessage}`,
            //         formulario: location.pathname,
            //     });
            //     hasCriticalError = true;
            // }

            if (!hasCriticalError) {
                // Deleta no banco de dados
                try {
                    toast.loading('Deletando imagens do banco de dados...', { id: toastId });
                    await api.delete('/api/imagens-ftp', { data: { imagesToDelete: imagesToDeleteBackend } });
                    toast.success('Imagens deletadas no banco com sucesso!', { id: toastId });
                } catch (errorDeleteDbImg) {
                    const errorMessage = errorDeleteDbImg.response?.data?.msg || errorDeleteDbImg.message || 'Erro desconhecido ao deletar imagens do banco.';
                    toast.error(`Erro ao deletar imagens do banco de dados: ${errorMessage}`, { id: toastId });
                    await logError({
                        email: user?.email || 'N/A',
                        log_erro: `Falha ao deletar imagens do banco de dados para o Veículo ${editValues?.id}: ${errorMessage}`,
                        formulario: location.pathname,
                    });
                    hasCriticalError = true;
                }
            }
        }

        // ENVIA NOVAS IMAGENS PARA O BACKEND PARA UPLOAD NO FTP
        if (!hasCriticalError && newlySelectedFiles.length > 0) {
            try {
                toast.loading('Salvando novas imagens do veículo...', { id: toastId });
                const formData = new FormData();

                for (let i = 0; i < newlySelectedFiles.length; i++) {
                    formData.append('files', newlySelectedFiles[i]);
                }

                await api.post(`/api/imagens-ftp/${editValues?.id}`, formData);
                toast.success('Novas imagens salvas com sucesso!', { id: toastId });
            } catch (err) {
                const errorMessage = err.response?.data?.msg || err.message || 'Erro salvar imagens';
                toast.error(`Falha no upload das imagens: ${errorMessage}`, { id: toastId });
                await logError({
                    email: user?.email || 'N/A',
                    log_erro: `Falha no upload de imagens do Veículo ${editValues?.id}: ${errorMessage}`,
                    formulario: location.pathname,
                });
                hasCriticalError = true; // Mark critical error
            }
        }

        // 2. UPLOAD DE NOVAS IMAGENS SE HOUVER
        // if (!hasCriticalError && newlySelectedFiles.length > 0) {
        //     try {
        //         toast.loading('Enviando novas imagens para nuvem...', { id: toastId });
        //         uploadedImageDetails = await Promise.all(newlySelectedFiles.map(async (file) => {
        //             return await Photos.uploadImage(existingImages[0].storage_path, file);
        //         }));
        //         toast.success('Novas imagens salvas na nuvem com sucesso!', { id: toastId });
        //     } catch (uploadError) {
        //         toast.error('Erro crítico no processo de upload de imagens.');
        //         logError({
        //             email: user?.email || 'N/A',
        //             log_erro: `Erro crítico inesperado no upload de imagens do Veículo ${editValues?.id}: ${uploadError.message || 'Erro desconhecido'}`,
        //             formulario: location.pathname,
        //         });
        //         hasCriticalError = true;
        //         uploadedImageDetails = [];
        //     }

        //     if (!hasCriticalError) {
        //         // SALVANDO NOVAS IMAGENS NO BANCO
        //         try {
        //             toast.loading('Associando novas imagens ao veículo...', { id: toastId });
        //             await api.post(`/api/imagens-firebase/${editValues?.id}`, { imagesToAdd: uploadedImageDetails });
        //             toast.success('Novas imagens associadas ao veículo com sucesso!', { id: toastId });
        //         } catch (errorNewImage) {
        //             const errorMessage = errorNewImage.response?.data?.msg || errorNewImage.message || 'Erro desconhecido ao associar novas imagens.';
        //             toast.error(`Falha ao associar novas imagens: ${errorMessage}`, { id: toastId });
        //             await logError({
        //                 email: user?.email || 'N/A',
        //                 log_erro: `Falha ao associar novas imagens do Veículo ${editValues?.id}: ${errorMessage}`,
        //                 formulario: location.pathname,
        //             });
        //             hasCriticalError = true;
        //         }
        //     }
        // }

        // 3. ENVIAR ATUALIZACAO DO VEICULO PARA BACKEND
        if (!hasCriticalError) {
            try {
                toast.loading('Atualizando informações do veículo...', { id: toastId });
                await api.put(`/api/anuncio/${editValues?.id}`, formDataToSubmit);
                toast.success('Veículo atualizado com sucesso!', { id: toastId });
            } catch (errorUpdateVehicle) {
                const errorMessage = errorUpdateVehicle.response?.data?.msg || errorUpdateVehicle.message || 'Erro desconhecido ao atualizar anúncio.';
                toast.error(`Erro inesperado ao atualizar veículo: ${errorMessage}`, { id: toastId });
                await logError({
                    email: user?.email || 'N/A',
                    log_erro: `Erro crítico inesperado ao atualizar Veículo ${editValues?.id}: ${errorMessage}`,
                    formulario: location.pathname,
                });
                hasCriticalError = true;
            }
        }

        if (!hasCriticalError) {
            toast.success('Veículo atualizado com sucesso!', { id: toastId });
            // Log de sucesso do usuário
            await logUsuarioForm({
                email: user?.email || 'N/A',
                formulario: location.pathname,
            });
            setTimeout(() => navigate(`/dashboard/anuncio/${editValues?.id}/detalhes`), 2000);
        } else {
            // Se um erro crítico ocorreu em qualquer passo, garante que o toast final seja de erro
            toast.error('O processo de atualização do veículo falhou.');
        }

        setIsButtonDisabled(true);
        setDisableDeleteImg(true);
    }

    if (!loading && !errorEditValues) {
        showFields = editValues.categoria.id !== '';
        // CATEGORIA CARRETA
        showDirecao = editValues.categoria.id !== 2;
        showCombustivel = editValues.categoria.id !== 2;
        showCambio = editValues.categoria.id !== 2;
        showKm = editValues.categoria.id !== 2;
        // CATEGORIA CARRO E CARRETA
        showTracao = editValues.categoria.id !== 3 && editValues.categoria.id !== 2;
        showCarroceria = editValues.categoria.id !== 3 && editValues.categoria.id !== 2;
        // CATEGORIA CAMINHAO E CARRO
        showTipo = editValues.categoria.id !== 1 && editValues.categoria.id !== 3;
        showModeloSelect = editValues.categoria.id !== 1 && editValues.categoria.id !== 3;
    }

    return (
        <>
            {loading && !errorEditValues && (
                <div className='card d-flex align-items-center p-4'>
                    <CircularProgress />
                </div>
            )}
            {!loading && errorEditValues && (
                <Alert severity='error'>{errorEditValues}</Alert>
            )}
            {!loading && !errorEditValues && user.atualizar && (
                <>
                    <div className='card shadow border-0 w-100 flex-row p-4 res-col'>
                        <h5 className='mb-0'>Editar anúncio #{editValues?.id}</h5>
                        <Breadcrumbs
                            aria-label='breadcrumb'
                            className='ms-auto breadcrumbs_'
                        >
                            <StyledBreadcrumb label='Dashboard' icon={<MdHome fontSize='small' />} />
                            <StyledBreadcrumb label='Anúncio' />
                            <StyledBreadcrumb label='Editar' />
                        </Breadcrumbs>
                    </div>
                    <Box
                        className='form'
                        component='form'
                        onSubmit={handleSubmit}
                        noValidate
                    >
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='card p-4 mt-0'>
                                    <h5 className='mb-4'>Informações</h5>

                                    <div className='row'>
                                        <div className='col'>
                                            <FormControl
                                                className='mb-4'
                                                fullWidth
                                            >
                                                <FormLabel
                                                    htmlFor='categoria'
                                                    sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                    error={error?.categoria_id}
                                                >
                                                    Categoria
                                                </FormLabel>
                                                <TextField
                                                    required
                                                    id='categoria'
                                                    name='categoria_id'
                                                    defaultValue={editValues.categoria?.nome}
                                                    disabled
                                                />
                                            </FormControl>
                                        </div>
                                        {showFields && (
                                            <>
                                                <div className='col'>
                                                    <CustomFormControl
                                                        className='mb-4'
                                                        fullWidth
                                                    >
                                                        <FormLabel
                                                            htmlFor='marca'
                                                            sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                            error={error?.marca_id}
                                                        >
                                                            Marca
                                                        </FormLabel>
                                                        <Select
                                                            required
                                                            labelId='marca-label'
                                                            id='marca'
                                                            name='marca_id'
                                                            variant='outlined'
                                                            displayEmpty
                                                            value={!editValues?.marca_id ? editValues.marca?.id : editValues.marca_id}
                                                            error={error?.marca_id}
                                                            color={error?.marca_id ? 'error' : 'primary'}
                                                            input={<OutlinedInput id='marca-input' />}
                                                            onChange={handleChange}
                                                            disabled={isButtonDisabled}
                                                        >
                                                            <MenuItem value=''>
                                                                <em>Selecione</em>
                                                            </MenuItem>
                                                            <MenuItem value={1}>BMW</MenuItem>
                                                            <MenuItem value={2}>CHEVROLET</MenuItem>
                                                            <MenuItem value={3}>DAF</MenuItem>
                                                            <MenuItem value={4}>FACCHINI</MenuItem>
                                                            <MenuItem value={5}>FORD</MenuItem>
                                                            <MenuItem value={6}>GUERRA</MenuItem>
                                                            <MenuItem value={7}>HONDA</MenuItem>
                                                            <MenuItem value={8}>HYUNDAI</MenuItem>
                                                            <MenuItem value={9}>IVECO</MenuItem>
                                                            <MenuItem value={10}>JEEP</MenuItem>
                                                            <MenuItem value={11}>KIA</MenuItem>
                                                            <MenuItem value={12}>LAND ROVER</MenuItem>
                                                            <MenuItem value={13}>LIBRELATO</MenuItem>
                                                            <MenuItem value={14}>MAN</MenuItem>
                                                            <MenuItem value={15}>MERCEDES-BENZ</MenuItem>
                                                            <MenuItem value={16}>MITSUBISHI</MenuItem>
                                                            <MenuItem value={17}>NISSAN</MenuItem>
                                                            <MenuItem value={18}>NOMA</MenuItem>
                                                            <MenuItem value={19}>PASTRE</MenuItem>
                                                            <MenuItem value={20}>RAM</MenuItem>
                                                            <MenuItem value={21}>RANDON</MenuItem>
                                                            <MenuItem value={22}>RODOFLEX</MenuItem>
                                                            <MenuItem value={23}>ROSSETTI</MenuItem>
                                                            <MenuItem value={24}>SCANIA</MenuItem>
                                                            <MenuItem value={25}>TOYOTA</MenuItem>
                                                            <MenuItem value={26}>VOLKSWAGEN</MenuItem>
                                                            <MenuItem value={27}>VOLVO</MenuItem>
                                                            <MenuItem value={28}>AIZI</MenuItem>
                                                        </Select>
                                                        {error?.marca_id && (
                                                            <FormHelperText error>{error.marca_id}</FormHelperText>
                                                        )}
                                                    </CustomFormControl>
                                                </div>
                                                <div className='col'>
                                                    <FormControl
                                                        className='mb-4'
                                                        fullWidth
                                                    >
                                                        <FormLabel
                                                            htmlFor='ano_fabricacao'
                                                            sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px', color: anoFabFocused ? 'primary.main' : '' }}
                                                            error={error?.ano_fabricacao}
                                                        >
                                                            Ano fabricação
                                                        </FormLabel>
                                                        <TextField
                                                            required
                                                            id='ano_fabricacao'
                                                            name='ano_fabricacao'
                                                            inputProps={{ maxLength: 4, inputMode: 'numeric' }}
                                                            variant='outlined'
                                                            value={editValues?.ano_fabricacao}
                                                            error={error?.ano_fabricacao}
                                                            helperText={error?.ano_fabricacao}
                                                            color={error?.ano_fabricacao ? 'error' : 'primary'}
                                                            onChange={handleChange}
                                                            onKeyPress={handleKeyPress}
                                                            onFocus={() => setAnoFabFocused(!anoFabFocused)}
                                                            onBlur={() => setAnoFabFocused(!anoFabFocused)}
                                                            disabled={isButtonDisabled}
                                                        />
                                                    </FormControl>
                                                </div>
                                                <div className='col'>
                                                    <FormControl
                                                        className='mb-4'
                                                        fullWidth
                                                    >
                                                        <FormLabel
                                                            htmlFor='ano_modelo'
                                                            sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px', color: anoModeloFocused ? 'primary.main' : '' }}
                                                            error={error?.ano_modelo}
                                                        >
                                                            Ano modelo
                                                        </FormLabel>
                                                        <TextField
                                                            required
                                                            id='ano_modelo'
                                                            name='ano_modelo'
                                                            inputProps={{ maxLength: 4, inputMode: 'numeric' }}
                                                            variant='outlined'
                                                            value={editValues?.ano_modelo}
                                                            error={error?.ano_modelo}
                                                            helperText={error?.ano_modelo}
                                                            color={error?.ano_modelo ? 'error' : 'primary'}
                                                            onChange={handleChange}
                                                            onKeyPress={handleKeyPress}
                                                            onFocus={() => setAnoModeloFocused(!anoModeloFocused)}
                                                            onBlur={() => setAnoModeloFocused(!anoModeloFocused)}
                                                            disabled={isButtonDisabled}
                                                        />
                                                    </FormControl>
                                                </div>
                                            </>
                                        )}
                                    </div>

                                    {showFields && (
                                        <div className='row'>
                                            {showTipo && (
                                                <div className='col'>
                                                    <CustomFormControl
                                                        className='mb-4'
                                                        fullWidth
                                                    >
                                                        <FormLabel
                                                            htmlFor='tipo'
                                                            sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                            error={error?.tipo}
                                                        >
                                                            Tipo
                                                        </FormLabel>
                                                        <Select
                                                            required
                                                            labelId='tipo-label'
                                                            id='tipo'
                                                            name='tipo'
                                                            value={editValues?.tipo}
                                                            error={error?.tipo}
                                                            displayEmpty
                                                            onChange={handleChange}
                                                            input={<OutlinedInput id='tipo-input' />}
                                                            color={error?.tipo ? 'error' : 'primary'}
                                                            disabled={isButtonDisabled}
                                                        >
                                                            <MenuItem value=''>
                                                                <em>Selecione</em>
                                                            </MenuItem>
                                                            <MenuItem value={'BITREM'}>BITREM</MenuItem>
                                                            <MenuItem value={'BITREM 9 EIXOS'}>BITREM 9 EIXOS</MenuItem>
                                                            <MenuItem value={'DOLLY'}>DOLLY</MenuItem>
                                                            <MenuItem value={'JULIETA'}>JULIETA</MenuItem>
                                                            <MenuItem value={'RODOTREM'}>RODOTREM</MenuItem>
                                                            <MenuItem value={'SEMI-REBOQUE'}>SEMI-REBOQUE</MenuItem>
                                                            <MenuItem value={'TRITREM'}>TRITREM</MenuItem>
                                                        </Select>
                                                        {error?.tipo && (
                                                            <FormHelperText error>{error.tipo}</FormHelperText>
                                                        )}
                                                    </CustomFormControl>
                                                </div>
                                            )}

                                            {showModeloSelect ? (
                                                <div className='col'>
                                                    <CustomFormControl
                                                        className='mb-4'
                                                        fullWidth
                                                    >
                                                        <FormLabel
                                                            htmlFor='modelo'
                                                            sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                            error={error?.modelo}
                                                        >
                                                            Modelo
                                                        </FormLabel>
                                                        <Select
                                                            required
                                                            labelId='modelo-label'
                                                            id='modelo'
                                                            name='modelo'
                                                            value={editValues?.modelo}
                                                            error={error?.modelo}
                                                            displayEmpty
                                                            onChange={handleChange}
                                                            input={<OutlinedInput id='modelo-input' />}
                                                            color={error?.modelo ? 'error' : 'primary'}
                                                            disabled={isButtonDisabled}
                                                        >
                                                            <MenuItem value=''>
                                                                <em>Selecione</em>
                                                            </MenuItem>
                                                            <MenuItem value='ALGODOEIRO'>ALGODOEIRO</MenuItem>
                                                            <MenuItem value='AUTO ESCOLA'>AUTO ESCOLA</MenuItem>
                                                            <MenuItem value='BASCULANTE'>BASCULANTE</MenuItem>
                                                            <MenuItem value='BAU BEBIDAS'>BAU BEBIDAS</MenuItem>
                                                            <MenuItem value='BAU FURGAO'>BAU FURGAO</MenuItem>
                                                            <MenuItem value='BAU SIDER'>BAU SIDER</MenuItem>
                                                            <MenuItem value='BOBINEIRO'>BOBINEIRO</MenuItem>
                                                            <MenuItem value='BOIADEIRO'>BOIADEIRO</MenuItem>
                                                            <MenuItem value='CANAVIEIRO'>CANAVIEIRO</MenuItem>
                                                            <MenuItem value='CARGA SECA'>CARGA SECA</MenuItem>
                                                            <MenuItem value='CARREGA TUDO'>CARREGA TUDO</MenuItem>
                                                            <MenuItem value='CAVAQUEIRA'>CAVAQUEIRA</MenuItem>
                                                            <MenuItem value='CEGONHA'>CEGONHA</MenuItem>
                                                            <MenuItem value='CEREALEIRO'>CEREALEIRO</MenuItem>
                                                            <MenuItem value='CEREALEIRO HOPPER'>CEREALEIRO HOPPER</MenuItem>
                                                            <MenuItem value='CHASSI'>CHASSI</MenuItem>
                                                            <MenuItem value='CONTAINER'>CONTAINER</MenuItem>
                                                            <MenuItem value='DOLLY'>DOLLY</MenuItem>
                                                            <MenuItem value='DOLLY 1 EIXO'>DOLLY 1 EIXO</MenuItem>
                                                            <MenuItem value='DOLLY 2 EIXO'>DOLLY 2 EIXO</MenuItem>
                                                            <MenuItem value='EXTENSIVA'>EXTENSIVA</MenuItem>
                                                            <MenuItem value='FLORESTAL'>FLORESTAL</MenuItem>
                                                            <MenuItem value='FRANGUEIRA'>FRANGUEIRA</MenuItem>
                                                            <MenuItem value='FRIGORIFICO'>FRIGORIFICO</MenuItem>
                                                            <MenuItem value='GAIOLA de GAS'>GAIOLA de GAS</MenuItem>
                                                            <MenuItem value='GRANELEIRO'>GRANELEIRO</MenuItem>
                                                            <MenuItem value='JULIETA ROLL ON'>JULIETA ROLL ON</MenuItem>
                                                            <MenuItem value='KIT SIDER'>KIT SIDER</MenuItem>
                                                            <MenuItem value='LAGARTIXA'>LAGARTIXA</MenuItem>
                                                            <MenuItem value='PORTA-CONTAINER'>PORTA-CONTAINER</MenuItem>
                                                            <MenuItem value='PRANCHA'>PRANCHA</MenuItem>
                                                            <MenuItem value='REBOQUE FLEX 2 EIXOS'>REBOQUE FLEX 2 EIXOS</MenuItem>
                                                            <MenuItem value='REBOQUE FLEX 3 EIXOS'>REBOQUE FLEX 3 EIXOS</MenuItem>
                                                            <MenuItem value='REBOQUE FLEX 4 EIXOS'>REBOQUE FLEX 4 EIXOS</MenuItem>
                                                            <MenuItem value='Roll ON OFF'>Roll ON OFF</MenuItem>
                                                            <MenuItem value='SEMI REBOQUE FLEX'>SEMI REBOQUE FLEX</MenuItem>
                                                            <MenuItem value='SILO'>SILO</MenuItem>
                                                            <MenuItem value='SUINEIRA'>SUINEIRA</MenuItem>
                                                            <MenuItem value='TANQUE AÇO'>TANQUE AÇO</MenuItem>
                                                            <MenuItem value='TANQUE ALUMINIO'>TANQUE ALUMINIO</MenuItem>
                                                            <MenuItem value='TANQUE GASES GLP'>TANQUE GASES GLP</MenuItem>
                                                            <MenuItem value='TANQUE INOX'>TANQUE INOX</MenuItem>
                                                            <MenuItem value='TANQUE ISOTERMICO'>TANQUE ISOTERMICO</MenuItem>
                                                        </Select>
                                                        {error?.modelo && (
                                                            <FormHelperText error>{error.modelo}</FormHelperText>
                                                        )}
                                                    </CustomFormControl>
                                                </div>
                                            ) : (
                                                <div className='col'>
                                                    <FormControl
                                                        className='mb-4'
                                                        fullWidth
                                                    >
                                                        <FormLabel
                                                            htmlFor='modelo'
                                                            sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px', color: modeloFocused ? 'primary.main' : '' }}
                                                            error={error?.modelo}
                                                        >
                                                            Modelo
                                                        </FormLabel>
                                                        <TextField
                                                            required
                                                            id='modelo'
                                                            name='modelo'
                                                            type='text'
                                                            variant='outlined'
                                                            value={editValues?.modelo}
                                                            error={error?.modelo}
                                                            helperText={error?.modelo}
                                                            color={error?.modelo ? 'error' : 'primary'}
                                                            onChange={handleChange}
                                                            onFocus={() => setModeloFocused(!modeloFocused)}
                                                            onBlur={() => setModeloFocused(!modeloFocused)}
                                                            disabled={isButtonDisabled}
                                                        />
                                                    </FormControl>
                                                </div>
                                            )}

                                            {showDirecao && (
                                                <div className='col'>
                                                    <CustomFormControl
                                                        className='mb-4'
                                                        fullWidth
                                                    >
                                                        <FormLabel
                                                            htmlFor='direcao'
                                                            sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                            error={error?.direcao}
                                                        >
                                                            Direção
                                                        </FormLabel>
                                                        <Select
                                                            required
                                                            labelId='direcao-label'
                                                            id='direcao'
                                                            name='direcao'
                                                            value={editValues?.direcao}
                                                            error={error?.direcao}
                                                            displayEmpty
                                                            onChange={handleChange}
                                                            input={<OutlinedInput id='direcao-input' />}
                                                            color={error?.direcao ? 'error' : 'primary'}
                                                            disabled={isButtonDisabled}
                                                        >
                                                            <MenuItem value=''>
                                                                <em>Selecione</em>
                                                            </MenuItem>
                                                            <MenuItem value={'MECÂNICA'}>MECÂNICA</MenuItem>
                                                            <MenuItem value={'HIDRÁULICA'}>HIDRÁULICA</MenuItem>
                                                            <MenuItem value={'ELÉTRICA'}>ELÉTRICA</MenuItem>
                                                        </Select>
                                                        {error?.direcao && (
                                                            <FormHelperText error>{error.direcao}</FormHelperText>
                                                        )}
                                                    </CustomFormControl>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {showFields && (
                                        <div className='row'>
                                            <div className='col'>
                                                <CustomFormControl
                                                    className='mb-4'
                                                    fullWidth
                                                >
                                                    <FormLabel
                                                        htmlFor='cor'
                                                        sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                        error={error?.cor}
                                                    >
                                                        Cor
                                                    </FormLabel>
                                                    <Select
                                                        required
                                                        labelId='cor-label'
                                                        id='cor'
                                                        name='cor'
                                                        value={editValues.cor}
                                                        error={error?.cor}
                                                        displayEmpty
                                                        onChange={handleChange}
                                                        input={<OutlinedInput id='cor-input' />}
                                                        color={error?.cor ? 'error' : 'primary'}
                                                        disabled={isButtonDisabled}
                                                    >
                                                        <MenuItem value=''>
                                                            <em>Selecione</em>
                                                        </MenuItem>
                                                        <MenuItem value={'AZUL'}>AZUL</MenuItem>
                                                        <MenuItem value={'AMARELO'}>AMARELO</MenuItem>
                                                        <MenuItem value={'BRANCO'}>BRANCO</MenuItem>
                                                        <MenuItem value={'PRETO'}>PRETO</MenuItem>
                                                        <MenuItem value={'PRATA'}>PRATA</MenuItem>
                                                        <MenuItem value={'BORDO'}>BORDO</MenuItem>
                                                        <MenuItem value={'CINZA'}>CINZA</MenuItem>
                                                        <MenuItem value={'DOURADO'}>DOURADO</MenuItem>
                                                        <MenuItem value={'LARANJA'}>LARANJA</MenuItem>
                                                        <MenuItem value={'MARROM'}>MARROM</MenuItem>
                                                        <MenuItem value={'VERDE'}>VERDE</MenuItem>
                                                        <MenuItem value={'VERMELHO'}>VERMELHO</MenuItem>
                                                        <MenuItem value={'VINHO'}>VINHO</MenuItem>
                                                        <MenuItem value={'ROSA'}>ROSA</MenuItem>
                                                    </Select>
                                                    {error?.cor && (
                                                        <FormHelperText error>{error.cor}</FormHelperText>
                                                    )}
                                                </CustomFormControl>
                                            </div>

                                            {showCombustivel && (
                                                <div className='col'>
                                                    <CustomFormControl
                                                        className='mb-4'
                                                        fullWidth
                                                    >
                                                        <FormLabel
                                                            htmlFor='combustivel'
                                                            sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                            error={error?.combustivel}
                                                        >
                                                            Combustível
                                                        </FormLabel>
                                                        <Select
                                                            required
                                                            labelId='combustivel-label'
                                                            id='combustivel'
                                                            name='combustivel'
                                                            value={editValues.combustivel}
                                                            error={error?.combustivel}
                                                            displayEmpty
                                                            onChange={handleChange}
                                                            input={<OutlinedInput id='combustivel-input' />}
                                                            color={error?.combustivel ? 'error' : 'primary'}
                                                            disabled={isButtonDisabled}
                                                        >
                                                            <MenuItem value=''>
                                                                <em>Selecione</em>
                                                            </MenuItem>
                                                            <MenuItem value={'GASOLINA'}>GASOLINA</MenuItem>
                                                            <MenuItem value={'ÁLCOOL'}>ÁLCOOL</MenuItem>
                                                            <MenuItem value={'DIESEL'}>DIESEL</MenuItem>
                                                            <MenuItem value={'FLEX'}>FLEX</MenuItem>
                                                            <MenuItem value={'HÍBRIDO'}>HÍBRIDO</MenuItem>
                                                            <MenuItem value={'ELÉTRICO'}>ELÉTRICO</MenuItem>
                                                        </Select>
                                                        {error?.combustivel && (
                                                            <FormHelperText error>{error.combustivel}</FormHelperText>
                                                        )}
                                                    </CustomFormControl>
                                                </div>
                                            )}

                                            {showCambio && (
                                                <div className='col'>
                                                    <CustomFormControl
                                                        className='mb-4'
                                                        fullWidth
                                                    >
                                                        <FormLabel
                                                            htmlFor='cambio'
                                                            sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                            error={error?.cambio}
                                                        >
                                                            Câmbio
                                                        </FormLabel>
                                                        <Select
                                                            required
                                                            labelId='cambio-label'
                                                            id='cambio'
                                                            name='cambio'
                                                            value={editValues.cambio}
                                                            error={error?.cambio}
                                                            displayEmpty
                                                            onChange={handleChange}
                                                            input={<OutlinedInput id='cambio-input' />}
                                                            color={error?.cambio ? 'error' : 'primary'}
                                                            disabled={isButtonDisabled}
                                                        >
                                                            <MenuItem value=''>
                                                                <em>Selecione</em>
                                                            </MenuItem>
                                                            <MenuItem value={'AUTOMÁTICO'}>AUTOMÁTICO</MenuItem>
                                                            <MenuItem value={'MANUAL'}>MANUAL</MenuItem>
                                                        </Select>
                                                        {error?.cambio && (
                                                            <FormHelperText error>{error.cambio}</FormHelperText>
                                                        )}
                                                    </CustomFormControl>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {showFields && (
                                        <div className='row'>
                                            {showTracao && (
                                                <div className='col'>
                                                    <CustomFormControl
                                                        className='mb-4'
                                                        fullWidth
                                                    >
                                                        <FormLabel
                                                            htmlFor='tracao'
                                                            sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                            error={error?.tracao}
                                                        >
                                                            Tração
                                                        </FormLabel>
                                                        <Select
                                                            required
                                                            labelId='tracao-label'
                                                            id='tracao'
                                                            name='tracao'
                                                            value={editValues.tracao}
                                                            error={error?.tracao}
                                                            displayEmpty
                                                            onChange={handleChange}
                                                            input={<OutlinedInput id='tracao-input' />}
                                                            color={error?.tracao ? 'error' : 'primary'}
                                                            disabled={isButtonDisabled}
                                                        >
                                                            <MenuItem value=''>
                                                                <em>Selecione</em>
                                                            </MenuItem>
                                                            <MenuItem value={'3/4 4X2'}>3/4 4X2</MenuItem>
                                                            <MenuItem value={'3/4 6X2'}>3/4 6X2</MenuItem>
                                                            <MenuItem value={'3/4 4X4'}>3/4 4X4</MenuItem>
                                                            <MenuItem value={'TOCO 4X2'}>TOCO 4X2</MenuItem>
                                                            <MenuItem value={'TOCO 4X4'}>TOCO 4X4</MenuItem>
                                                            <MenuItem value={'TRUCK 6X2'}>TRUCK 6X2</MenuItem>
                                                            <MenuItem value={'TRAÇADO 6X4'}>TRAÇADO 6X4</MenuItem>
                                                            <MenuItem value={'TRAÇADO 6X6'}>TRAÇADO 6X6</MenuItem>
                                                            <MenuItem value={'BITRUCK 8X2'}>BITRUCK 8X2</MenuItem>
                                                            <MenuItem value={'BITRUCK 8X4'}>BITRUCK 8X4</MenuItem>
                                                        </Select>
                                                        {error?.tracao && (
                                                            <FormHelperText error>{error.tracao}</FormHelperText>
                                                        )}
                                                    </CustomFormControl>
                                                </div>
                                            )}

                                            {showCarroceria && (
                                                <div className='col'>
                                                    <CustomFormControl
                                                        className='mb-4'
                                                        fullWidth
                                                    >
                                                        <FormLabel
                                                            htmlFor='carroceria'
                                                            sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px' }}
                                                            error={error?.carroceria}
                                                        >
                                                            Carroceria
                                                        </FormLabel>
                                                        <Select
                                                            required
                                                            labelId='carroceria-label'
                                                            id='carroceria'
                                                            name='carroceria'
                                                            value={editValues?.carroceria}
                                                            error={error?.carroceria}
                                                            displayEmpty
                                                            onChange={handleChange}
                                                            input={<OutlinedInput id='carroceria-input' />}
                                                            color={error?.carroceria ? 'error' : 'primary'}
                                                            disabled={isButtonDisabled}
                                                        >
                                                            <MenuItem value=''>
                                                                <em>Selecione</em>
                                                            </MenuItem>
                                                            <MenuItem value='CAVALO MECÂNICO'>CAVALO MECÂNICO</MenuItem>
                                                            <MenuItem value='AVES VIVAS'>AVES VIVAS</MenuItem>
                                                            <MenuItem value='BAÚ BEBIDAS'>BAÚ BEBIDAS</MenuItem>
                                                            <MenuItem value='BAÚ FRIGORÍFICO'>BAÚ FRIGORÍFICO</MenuItem>
                                                            <MenuItem value='BAÚ FURGÃO'>BAÚ FURGÃO</MenuItem>
                                                            <MenuItem value='BAÚ SIDER'>BAÚ SIDER</MenuItem>
                                                            <MenuItem value='BAÚ TÉRMICO'>BAÚ TÉRMICO</MenuItem>
                                                            <MenuItem value='BETONEIRA'>BETONEIRA</MenuItem>
                                                            <MenuItem value='BOIADEIRO'>BOIADEIRO</MenuItem>
                                                            <MenuItem value='BOMBA DE CONCRETO'>BOMBA DE CONCRETO</MenuItem>
                                                            <MenuItem value='BOMBEIRO'>BOMBEIRO</MenuItem>
                                                            <MenuItem value='CAÇAMBA BASCULANTE'>CAÇAMBA BASCULANTE</MenuItem>
                                                            <MenuItem value='CAÇAMBA CABINE SUPLEMENTAR'>CAÇAMBA CABINE SUPLEMENTAR</MenuItem>
                                                            <MenuItem value='CEGONHA'>CEGONHA</MenuItem>
                                                            <MenuItem value='CESTO AEREO ISOLADO'>CESTO AEREO ISOLADO</MenuItem>
                                                            <MenuItem value='COMBOIO'>COMBOIO</MenuItem>
                                                            <MenuItem value='CARGA SECA'>CARGA SECA</MenuItem>
                                                            <MenuItem value='CARROCERIA CABINE SUPLEMENTAR'>CARROCERIA CABINE SUPLEMENTAR</MenuItem>
                                                            <MenuItem value='CHASSIS'>CHASSIS</MenuItem>
                                                            <MenuItem value='COLETOR DE LIXO'>COLETOR DE LIXO</MenuItem>
                                                            <MenuItem value='CONTEINER 20 PÉS'>CONTEINER 20 PÉS</MenuItem>
                                                            <MenuItem value='DISTRIBUIDOR DE FERTILIZANTES'>DISTRIBUIDOR DE FERTILIZANTES</MenuItem>
                                                            <MenuItem value='ESCAVADEIRA VALETADEIRA'>ESCAVADEIRA VALETADEIRA</MenuItem>
                                                            <MenuItem value='ESPARGIDOR'>ESPARGIDOR</MenuItem>
                                                            <MenuItem value='FOOD TRUCK'>FOOD TRUCK</MenuItem>
                                                            <MenuItem value='GRADE BAIXA'>GRADE BAIXA</MenuItem>
                                                            <MenuItem value='GAIOLA DE GÁS'>GAIOLA DE GÁS</MenuItem>
                                                            <MenuItem value='GRANELEIRO'>GRANELEIRO</MenuItem>
                                                            <MenuItem value='GUINCHO MUNCK'>GUINCHO MUNCK</MenuItem>
                                                            <MenuItem value='GRUA CARROCERIA'>GRUA CARROCERIA</MenuItem>
                                                            <MenuItem value='PERFURATRIZ'>PERFURATRIZ</MenuItem>
                                                            <MenuItem value='PLATAFORMA'>PLATAFORMA</MenuItem>
                                                            <MenuItem value='PLATAFORMA GUINCHO'>PLATAFORMA GUINCHO</MenuItem>
                                                            <MenuItem value='POLIGUINDASTE'>POLIGUINDASTE</MenuItem>
                                                            <MenuItem value='ROLL ON OFF'>ROLL ON OFF</MenuItem>
                                                            <MenuItem value='SILO'>SILO</MenuItem>
                                                            <MenuItem value='SUINEIRA'>SUINEIRA</MenuItem>
                                                            <MenuItem value='TANQUE AÇO'>TANQUE AÇO</MenuItem>
                                                            <MenuItem value='TANQUE INOX'>TANQUE INOX</MenuItem>
                                                            <MenuItem value='TANQUE ISOTÉRMICO'>TANQUE ISOTÉRMICO</MenuItem>
                                                            <MenuItem value='TANQUE HIDRO VÁCUO'>TANQUE HIDRO VÁCUO</MenuItem>
                                                            <MenuItem value='TANQUE PIPA'>TANQUE PIPA</MenuItem>
                                                            <MenuItem value='TORA FLORESTAL'>TORA FLORESTAL</MenuItem>
                                                            <MenuItem value='TRANSBORDO CANAVIEIRO'>TRANSBORDO CANAVIEIRO</MenuItem>
                                                            <MenuItem value='TRIO ELÉTRICO'>TRIO ELÉTRICO</MenuItem>
                                                            <MenuItem value='VARREDEIRA'>VARREDEIRA</MenuItem>
                                                        </Select>
                                                        {error?.carroceria && (
                                                            <FormHelperText error>{error.carroceria}</FormHelperText>
                                                        )}
                                                    </CustomFormControl>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {showFields && (
                                        <div className='row'>
                                            {showKm && (
                                                <div className='col'>
                                                    <FormControl
                                                        className='mb-4'
                                                        fullWidth
                                                    >
                                                        <FormLabel
                                                            htmlFor='km'
                                                            sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px', color: kmFocused ? 'primary.main' : '' }}
                                                            error={error?.km}
                                                        >
                                                            Km
                                                        </FormLabel>
                                                        <NumericFormat
                                                            required
                                                            id='km'
                                                            name='km'
                                                            customInput={TextField}
                                                            value={editValues.km}
                                                            thousandSeparator
                                                            suffix=' Km'
                                                            variant='outlined'
                                                            error={error?.km}
                                                            helperText={error?.km}
                                                            color={error?.km ? 'error' : 'primary'}
                                                            onValueChange={(values) => handleNumericInputChange(values, 'km')}
                                                            onFocus={() => setKmFocused(!kmFocused)}
                                                            onBlur={() => setKmFocused(!kmFocused)}
                                                            disabled={isButtonDisabled}
                                                        />
                                                    </FormControl>
                                                </div>
                                            )}

                                            <div className='col'>
                                                <FormControl
                                                    className='mb-4'
                                                    fullWidth
                                                >
                                                    <FormLabel
                                                        htmlFor='valor'
                                                        sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px', color: valorFocused ? 'primary.main' : '' }}
                                                        error={error?.valor}
                                                    >
                                                        Valor
                                                    </FormLabel>
                                                    <NumericFormat
                                                        required
                                                        id='valor'
                                                        name='valor'
                                                        customInput={TextField}
                                                        value={editValues?.valor}
                                                        thousandSeparator
                                                        prefix='R$ '
                                                        variant='outlined'
                                                        error={error?.valor}
                                                        helperText={error?.valor}
                                                        color={error?.valor ? 'error' : 'primary'}
                                                        onValueChange={(values) => handleNumericInputChange(values, 'valor')}
                                                        onFocus={() => setValorFocused(!valorFocused)}
                                                        onBlur={() => setValorFocused(!valorFocused)}
                                                        disabled={isButtonDisabled}
                                                    />
                                                </FormControl>
                                            </div>
                                        </div>
                                    )}

                                    {showFields && (
                                        <div className='row'>
                                            <div className='col'>
                                                <FormControl
                                                    className='mb-4'
                                                    fullWidth
                                                >
                                                    <FormLabel
                                                        htmlFor='observacao'
                                                        sx={{ fontSize: '12px', fontWeight: 500, marginBottom: '5px', color: observacaoFocused ? 'primary.main' : '' }}
                                                        error={error?.observacao}
                                                    >
                                                        Observação
                                                    </FormLabel>
                                                    <TextField
                                                        required
                                                        id='observacao'
                                                        name='observacao'
                                                        type='text'
                                                        rows={5}
                                                        multiline
                                                        variant='outlined'
                                                        value={editValues?.observacao}
                                                        error={error?.observacao}
                                                        helperText={error?.observacao}
                                                        color={error?.observacao ? 'error' : 'primary'}
                                                        onChange={handleChange}
                                                        onFocus={() => setObservacaoFocused(!observacaoFocused)}
                                                        onBlur={() => setObservacaoFocused(!observacaoFocused)}
                                                        disabled={isButtonDisabled}
                                                    />
                                                </FormControl>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className='card p-4 mt-0'>
                            <div className='imagesUpload mb-4'>
                                <h5 className='mb-4'>Imagens</h5>
                                <div className='imgUploadBox d-flex align-items-center'>
                                    {allPreviewURLs.length > 0 ? (
                                        allPreviewURLs.map((url, index) => (
                                            <div key={index} className='uploadBox'>
                                                <Button
                                                    className='remove'
                                                    onClick={() => handleDeleteImage(url)}
                                                    disabled={disableDeleteImg}
                                                >
                                                    <MdClear />
                                                </Button>
                                                <div className='box'>
                                                    <LazyLoadImage
                                                        src={url}
                                                        effect='blur'
                                                        alt={`Imagem ${index + 1}`}
                                                        width={'100%'}
                                                        height={'100%'}
                                                        onError={({ currentTarget }) => {
                                                            currentTarget.onerror = null;
                                                            currentTarget.src = "/default.jpg";
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p>Nenhuma imagem selecionada ou existente</p>
                                    )}
                                    <div className='uploadBox'>
                                        <input
                                            type='file'
                                            multiple
                                            accept='image/*'
                                            onChange={handleImageChange}
                                            disabled={isButtonDisabled}
                                        />
                                        <div className='info'>
                                            <MdImage />
                                            <p>Selecionar imagens</p>
                                        </div>
                                    </div>
                                </div>
                                {error?.imagem &&
                                    <p className='mt-3' style={{ color: '#d32f2f', fontSize: '12px' }}>{error?.imagem}</p>
                                }
                                {
                                    uploadError &&
                                    <p className='mt-3' style={{ color: '#d32f2f', fontSize: '12px' }}>{uploadError}</p>
                                }
                            </div>

                            <div className='d-flex justify-content-between'>
                                <Button
                                    color='error'
                                    variant='contained'
                                    onClick={() => navigate('/dashboard')}
                                    disabled={isButtonDisabled}
                                >
                                    Cancelar
                                </Button>

                                <Button
                                    type='submit'
                                    variant='contained'
                                    sx={{ color: '#fff' }}
                                    disabled={!showFields}
                                    loading={isButtonDisabled}
                                >
                                    Salvar
                                </Button>
                            </div>
                        </div>
                    </Box>
                </>
            )}
            {!loading && !errorEditValues && !user.atualizar && (
                <Alert severity='warning'>Seu usuário não possui permissão para editar!</Alert>
            )}
        </>
    )
}

export default DashboardEditarAnuncio;
